export function currencyFilter(value) {
    let symbol = "€"
    switch (store.getters['main/currency'].symbol) {
        case "eur" : symbol = "€";break;
        case "dz": symbol = "Dz";break;
     };
    return (value || 0) + ' ' + symbol;
}
